import { render, staticRenderFns } from "./GiftProductList.vue?vue&type=template&id=63fd9dd8"
import script from "./GiftProductList.vue?vue&type=script&lang=js"
export * from "./GiftProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports